<p class="graph-title font-primary--b">{{ title | translate }}</p>
<div
  class="graph-component"
  [class.unsubscribed]="!subscribed"
  [class.wideMode]="wideMode"
  *ngIf="!isEmpty"
>
  <ng-container
    *ngIf="chartCategory === 'psychometrics_vocational_interests_self_efficacy'"
  >
    <canvas
      #chartCanvas
      #{{chartId}}
      id="{{ chartId }}"
      width="1000"
      height="500"
    ></canvas>
  </ng-container>
</div>
<div *ngIf="isEmpty">
  <h1 class="graph-title graph-title-no-data">
    {{ "chartLabels.no-data" | translate }}
  </h1>
</div>
